import {ProModal, ProModalProps} from 'Components/ProModal';
import ProForm from 'Components/ProForm';
import {Input, InputNumber, message} from 'antd';
import useRequestFn from 'Utils/Hooks/useRequestFn';
import {getDirList, MenuItem, menuSave} from '../../service';
import SelectDict from 'Features/Select/SelectDict';
import {useMount} from 'react-use';
import {useForm, useWatch} from 'antd/es/form/Form';
import {useDict} from '../../useDict';
import {errorMessage} from 'Utils/common';
import useRequest from '../../../../../Utils/Hooks/useRequest';

interface MenuModalProps extends ProModalProps {
    action: 'add' | 'edit';
    data?: Partial<MenuItem>;
}

export function MenuModal({action, data, onOk, ...props}: MenuModalProps) {
    const [form] = useForm<MenuItem>();
    const dict = useDict();

    const [dirList] = useRequest(getDirList);

    const levelType = useWatch('levelType', form);

    useMount(() => {
        if (data) form.setFieldsValue(data);
    });

    function onTypeChange(levelType: string) {
        if (levelType === 'DIMTYPE100001') {
            form.setFieldValue('parentId', '0');
        }
        form.validateFields();
    }

    const [onFinish] = useRequestFn(async (data: MenuItem) => {
        try {
            await menuSave(data);
            message.success('保存成功!');
            onOk?.();
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    return (
        <ProModal.Form
            form={form}
            title={action === 'edit' ? '编辑菜单' : '增加同级'}
            onFinish={onFinish}
            formProps={{columns: 1}}
            {...props}>
            <ProForm.Field name="id" hidden>
                <Input />
            </ProForm.Field>

            <ProForm.Field
                label="名称"
                name="name"
                rules={[{required: true, message: '请输入${label}'}]}>
                <Input placeholder="请输入名称" />
            </ProForm.Field>

            <ProForm.Field
                label="编码"
                name="code"
                disabled={action === 'edit'}
                rules={[{required: true, message: '请输入${label}'}]}>
                <Input placeholder="请输入系统唯一的菜单编码" />
            </ProForm.Field>

            <ProForm.Field
                label="类型"
                name="levelType"
                disabled={action === 'edit'}>
                <SelectDict
                    placeholder="请选择"
                    options={dict.MenuType.data}
                    onChange={onTypeChange}
                />
            </ProForm.Field>

            <ProForm.Field
                label="菜单所属目录"
                name="parentId"
                disabled={action === 'edit' || levelType === 'DIMTYPE100001'}
                required={levelType === 'DIMTYPE100002'}
                rules={[
                    {
                        message: '请选择${label}',
                        validator: (_rule, value) => {
                            if (levelType === 'DIMTYPE100002' && value === '0')
                                return Promise.reject('请选择菜单所属目录');
                            return Promise.resolve();
                        },
                    },
                ]}>
                <SelectDict
                    placeholder="请选择"
                    options={[
                        {label: '无', value: '0'},
                        ...(dirList || []).map(item => ({
                            label: item.name,
                            value: item.id,
                        })),
                    ]}
                />
            </ProForm.Field>

            <ProForm.Field
                label="排序"
                name="sort"
                initialValue={1}
                disabled={action === 'edit'}
                rules={[
                    {
                        required: ['DIMTYPE100001', 'DIMTYPE100002'].includes(
                            levelType,
                        ),
                    },
                ]}>
                <InputNumber
                    className="full"
                    min={1}
                    max={50}
                    placeholder="请输入大于0小于50的整数"
                />
            </ProForm.Field>
        </ProModal.Form>
    );
}
